import { render, staticRenderFns } from "./InfoHistory.vue?vue&type=template&id=0de4c4ce&scoped=true"
import script from "./InfoHistory.vue?vue&type=script&lang=js"
export * from "./InfoHistory.vue?vue&type=script&lang=js"
import style0 from "./InfoHistory.vue?vue&type=style&index=0&id=0de4c4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4c4ce",
  null
  
)

export default component.exports